import React from 'react'
function Footer() {
  return (
    <div className="flex text-white bg-slate-300">
        <div className="flex w-screen flex-col justify-between md:flex-row">
            <div className="m-2 text-center">
            <div className="flex justify-center text-center">
                <svg className="w-10 font-bold text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="{1.5}" stroke="currentColor" class="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
            </div>
            <h1 className="font-mono text-xl font-bold text-blue-600">WHERE TO FIND ME</h1>
            <p className="text-black font-bold">New Modern Boys Hostel(Kolkata)</p>
            <p className="text-black font-bold">700150 India</p>
            </div>
            <div className="m-2 text-center">
            <div className="flex justify-center text-center">
                <svg className="w-10 font-bold text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="h-6 w-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
            </div>
            <h1 className="font-mono text-xl font-bold text-blue-600">EMAIL ME AT</h1>
            <p className="text-black font-bold">rahul14.12kr@gmail.com</p>
            </div>
            <div className="m-2 text-center">
            <div className="flex justify-center text-center">
                <svg className="w-10 font-bold text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="h-6 w-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 9.75v-4.5m0 4.5h4.5m-4.5 0l6-6m-3 18c-8.284 0-15-6.716-15-15V4.5A2.25 2.25 0 014.5 2.25h1.372c.516 0 .966.351 1.091.852l1.106 4.423c.11.44-.054.902-.417 1.173l-1.293.97a1.062 1.062 0 00-.38 1.21 12.035 12.035 0 007.143 7.143c.441.162.928-.004 1.21-.38l.97-1.293a1.125 1.125 0 011.173-.417l4.423 1.106c.5.125.852.575.852 1.091V19.5a2.25 2.25 0 01-2.25 2.25h-2.25z" />
                </svg>
            </div>
            <h1 className="font-mono text-xl font-bold text-blue-600">CALL ME AT</h1>
            <p className="text-black font-bold">8240662720</p>
            </div>
        </div>
    </div>

  )
}
export default Footer